import { withOverrideLegacy } from '~/App/hocs/with-override-legacy';

import { Other } from './Other'
import { loadData } from './Other.LoadData';


export default withOverrideLegacy(Other, loadData);